import src from "IMAGE";
export default { src, width: 1920, height: 547, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOElEQVR42h2JsQkAQAjE3H8e93ADrX2sLLRReM4iEBKKCMlM6W6ZmQOOhkdmxv6cq4pn94CjqSl/gPE5XwmvE/cAAAAASUVORK5CYII="};
